import { render, staticRenderFns } from "./tcbs.vue?vue&type=template&id=b1323854&scoped=true&"
import script from "./tcbs.vue?vue&type=script&lang=js&"
export * from "./tcbs.vue?vue&type=script&lang=js&"
import style0 from "./tcbs.vue?vue&type=style&index=0&id=b1323854&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1323854",
  null
  
)

export default component.exports